import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  FANTASY_ANDROID,
  FANTASY_IOS,
  FANTASY_WEBSITE,
  WEB,
  WEBVIEW,
} from "../../Common/constants";
import useDataLayer from "../../Common/hooks/useDataLayer";
import useIntersectionObserver from "../../Common/hooks/useIntersectionObserver";
import { getTranslations, isAndroid, isIOS } from "../../Common/utils";
import {
  currentFixture,
  getUpcomingThreeFixtures,
} from "../../Common/utils/fixture";
import { Anchor } from "../Anchor";
import UpcomingRaceCard from "./UpcomingRaceCard";
import { useViewFullScheduleDL } from "./useViewFullScheduleDL";

const UpcomingRaceSection = ({ currentSeasonYear = null }) => {
  const upcomingRaceSectionRef = useRef(null);
  const pushToDataLayer = useDataLayer();
  const userState = useSelector((state) => state.user);
  const webview = userState?.webview;
  const commonConfigState = useSelector((state) => state.commonConfig);
  const fixtureCircuitConfigState = useSelector(
    (state) => state.fixtureCircuitConfig
  );
  const fixtures = fixtureCircuitConfigState?.data?.fixtures;
  const { handleViewFullScheduleDL } = useViewFullScheduleDL();
  const [isDataPushed, setIsDataPushed] = useState(false);
  const webConfigData = commonConfigState?.data?.config;

  const primaryMenuItems =
    webConfigData?.clientHeaderFooter?.header?.menuItems?.primaryMenuItem;

  const scheduleMenuItem = primaryMenuItems?.find(
    (menuItem) => menuItem?.menuTitle === "Schedule"
  );

  const upcomingFixtures = getUpcomingThreeFixtures(
    fixtures,
    currentFixture(fixtures)
  );
  const viewFullScheduleLinkText = getTranslations(
    "view_full_schedule_link_text",
    "View Full Schedule"
  );
  const viewFullScheduleLink = scheduleMenuItem?.menuUrl;

  const handleViewFullScheduleLink = () => {
    handleViewFullScheduleDL({
      path: viewFullScheduleLink,
      actionType: "View Full Schedule",
      clickText: viewFullScheduleLinkText,
      locationInPage: "Next Race",
      pageName: "Home",
    });
  };
  const isUpcomingRaceSectionRefIntersectingMap = useIntersectionObserver(
    upcomingRaceSectionRef,
    {
      // threshold: isMobile() ? 0.5 : 1,
      threshold: 0.75,
    }
  );

  useEffect(() => {
    const dataLayerObject = {
      actionType: "view",
      locationInPage: "Race details",
      pageName: "Home",
      platform: isAndroid()
        ? FANTASY_ANDROID
        : isIOS()
        ? FANTASY_IOS
        : FANTASY_WEBSITE,
      componentType: webview ? WEBVIEW : WEB,
    };

    if (upcomingRaceSectionRef.current) {
      isUpcomingRaceSectionRefIntersectingMap.forEach((value, key) => {
        if (value && !isDataPushed) {
          pushToDataLayer("widget_impressions", dataLayerObject);
          setIsDataPushed(true);
        }
      });
    }
  }, [isUpcomingRaceSectionRefIntersectingMap]);

  return (
    <>
      <section className="si-upcomingRace__wrap" ref={upcomingRaceSectionRef}>
        <div className="si-main__container">
          <div className="si-upcomingRace__head">
            <h2 className="si-upcomingRace__title">
              {getTranslations("next_race_heading", "Next Race", "caps")}
            </h2>

            <Anchor
              linkCls={"si-btn si-btn__link"}
              icon={"f1i-chevron-right"}
              linkText={viewFullScheduleLinkText}
              hyperLink={viewFullScheduleLink}
              extraAttri={{
                onClick: handleViewFullScheduleLink,
              }}
            />
          </div>
        </div>
        <div className="si-main__container">
          <div className="si-upcomingRace__list">
            <ul>
              {upcomingFixtures?.map((fixture) => {
                return (
                  <li key={fixture?.RaceId}>
                    <UpcomingRaceCard
                      fixture={fixture}
                      currentSeasonYear={currentSeasonYear}
                    />
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export { UpcomingRaceSection };
